import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Input } from '../ui/input';

/**
 * Password field with a lock icon and a show/hide (eye) toggle.
 * Reused across login, register, and reset-password flows.
 */
export const PasswordInput = ({
  id = 'password',
  value,
  onChange,
  placeholder = 'Your password',
  required = true,
  minLength = 8,
  autoComplete = 'current-password',
  testid = 'input-password',
  autoFocus = false,
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative mt-1.5">
      <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-cn-text-muted pointer-events-none" />
      <Input
        id={id}
        type={show ? 'text' : 'password'}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        value={value}
        onChange={onChange}
        className="pl-9 pr-11 h-11 rounded-xl border-cn-border bg-white"
        placeholder={placeholder}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Hide password' : 'Show password'}
        title={show ? 'Hide password' : 'Show password'}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-lg text-cn-text-muted hover:text-cn-primary hover:bg-cn-soft/60 transition-colors"
        data-testid={`${testid}-toggle`}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
